export default __webpack_public_path__ + "static/media/napoje_gorace.49f91dcd.svg";